// Edytuj tutaj nazwy, ceny i opisy planów Rmobile

// 2 pakiety na telefon (reszta opisów do uzupełnienia przez Ciebie)
export const PLANS = [
  {
    id: "podstawowy",
    name: "Podstawowy",
    price: 24,
    period: "/mies.",
    tagline: "Do uzupełnienia",
    description: "Opis pakietu – uzupełnij tutaj.",
    features: [
      "Punkt 1 – do uzupełnienia",
      "Punkt 2 – do uzupełnienia",
      "Punkt 3 – do uzupełnienia",
    ],
    featured: false,
  },
  {
    id: "rozszerzony",
    name: "Rozszerzony",
    price: 36,
    period: "/mies.",
    tagline: "Do uzupełnienia",
    description: "Opis pakietu – uzupełnij tutaj.",
    features: [
      "Punkt 1 – do uzupełnienia",
      "Punkt 2 – do uzupełnienia",
      "Punkt 3 – do uzupełnienia",
    ],
    featured: true,
  },
];

// Dodatkowe paczki internetu do wybicia z telefonu kodem USSD
export const EXTRA_INTERNET_CODES = [
  { code: "*171*4*5#",   size: "5 GB",   price: 4  },
  { code: "*171*4*30#",  size: "30 GB",  price: 12 },
  { code: "*171*4*60#",  size: "60 GB",  price: 18 },
  { code: "*171*4*120#", size: "120 GB", price: 25 },
];

// Pakiety Internetu mobilnego (osobna zakładka)
export const MOBILE_INTERNET_PLANS = [
  { id: "mi-60",  name: "60 GB",  price: 39, period: "/mies." },
  { id: "mi-200", name: "200 GB", price: 69, period: "/mies." },
  { id: "mi-500", name: "500 GB", price: 99, period: "/mies." },
];

// Globalne teksty marki
export const BRAND = {
  name: "Rmobile",
  tagline: "Sieć, która działa dla Ciebie",
  hero: {
    eyebrow: "Polska sieć komórkowa",
    title: "Mobilna wolność\nw zasięgu Twojej dłoni.",
    subtitle:
      "Przejrzyste abonamenty, brak ukrytych opłat, zasięg w całej Polsce i Europie. Wybierz Rmobile i zacznij rozmawiać bez ograniczeń.",
  },
  contact: {
    email: "bok@republikamobile.pl",
    phone: "22 350 88 88",
    address: "",
    hours: "Pon–Sob: 08:00–22:00",
  },
};
